import type { GoogleSignupProps } from '../../lib/api';

import { useClient } from './useClient';

type GoogleCallback = (params: GoogleSignupProps) => void;
export function useGoogleAuthentication(cb: GoogleCallback) {
  const { redirectURL } = useClient();

  const googleLogin = () => {
    //@ts-ignore
    gapi.load('auth2', async function () {
      //@ts-ignore
      await gapi.auth2.init().then((authInstancxe) => {
        authInstancxe.signIn().then((googleUser: any) => {
          const profile = googleUser.getBasicProfile();
          const id_token = googleUser.getAuthResponse().id_token;
          const email = profile.getEmail();
          cb({ token: id_token, email, region: 'AU', redirectURL });
        });
      });
    });
  };
  return { googleLogin };
}
